import { AngularMaterialModule } from './shared/material.module';
import { WelcomePageComponent } from './modules/welcome/pages/welcome-page/welcome-page.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '@uw-env/environment';
//import { AuthModule } from './modules/auth/auth.module';
import { ThemesModule } from './themes/themes.module';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { SharedModule } from './shared/shared.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CoreModule } from './core/core.module';
//import { KeyboardShortcutsModule } from 'ng-keyboard-shortcuts';
import localeFr from '@angular/common/locales/fr';
import { registerLocaleData } from '@angular/common';
// import { WelcomeModule } from './modules/welcome/welcome.module';
import { LoginPageComponent } from './modules/auth/pages/login-page/login-page.component';
import { LoginEntryComponent } from './modules/auth/pages/login-page/login-entry.component';
import { LandingPageComponent } from './modules/sidebar-views/pages/landing-page/landing-page.component';
import { ForgotPasswordComponent } from './modules/auth/pages/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './modules/auth/pages/reset-password/reset-password.component';
import { ChangePasswordComponent } from './modules/auth/pages/change-password/change-password.component';
import { TranslateModule } from '@ngx-translate/core';
import { DonationOptoutModalComponent } from './modules/welcome/modals/donation-optout-modal/donation-optout-modal.component';
import { CampaignStateService } from './core/services/campaign-state.service';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { UserFeatureStore } from './store/user';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { CampaignFeatureStore } from './store/campaign';
import { CampaignEffects } from './store/campaign/campaign.effects';
import { DonorCampaignsListResolver } from './core/resolvers/donor-campaign-list-resolver';
import { StandaloneForgotPasswordComponent } from './modules/auth/pages/standalone-forgot-password/standalone-forgot-password.component';
import { LanguageSelectorModule } from './shared/components/language-selector';
import { SelectDonorCampaignsListResolver } from './core/resolvers/select-donor-campaign-list-resolver';
import { MFAInputAriaLabelDirective, MfaComponent } from './modules/auth/pages/mfa/mfa.component';
import { AppSelectionComponent } from './modules/auth/pages/app-selection/app-selection.component';
import { UserRegistrationFeedbackComponent } from './modules/auth/pages/user-registration-feedback/user-registration-feedback.component';
import { CodeInputModule } from 'angular-code-input';
import { RegistrationTokenVerificationComponent } from './modules/auth/pages/registration-token-verification/registration-token-verification.component';
import { AuthPagesResolver } from './modules/auth/resolvers/auth-pages.resolver';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive'; // this includes the core NgIdleModule but includes keepalive providers for easy wireup
import { PasswordExpiredComponent } from './modules/auth/pages/password-expired/password-expired.component';
import { ChangePasswordFormComponent } from './modules/auth/pages/change-password-form/change-password-form.component';
import { FocusModule } from './shared/directives/focus/focus.module';
import { MyCampaignModalComponent } from './modules/welcome/modals/my-campaign-modal/my-campaign-modal.component';
import { MyCampaignModule } from './modules/my-campaign/my-campaign.module';
import { PasswordRegistrationComponent } from './shared/components/password-registration/password-registration.component';
import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';
registerLocaleData(localeFr, 'fr');
@NgModule({ declarations: [AppComponent], bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        ReactiveFormsModule,
        FormsModule,
        MyCampaignModule,
        ServiceWorkerModule.register('ngsw-worker.js', { enabled: (environment as any).enableServiceWorker ?? environment.production }),
        ThemesModule,
        SharedModule,
        AngularMaterialModule,
        CoreModule,
        TranslateModule,
        BrowserAnimationsModule,
        CodeInputModule,
        NgIdleKeepaliveModule.forRoot(),
        StoreModule.forRoot({}),
        EffectsModule.forRoot([CampaignEffects]),
        StoreModule.forFeature(UserFeatureStore.userFeature),
        StoreModule.forFeature(CampaignFeatureStore.campaignFeature),
        StoreDevtoolsModule.instrument({
            name: 'UW Dev Envirnoment',
            maxAge: 25,
        }),
        LanguageSelectorModule,
        FocusModule,
        PasswordRegistrationComponent
        //KeyboardShortcutsModule.forRoot(),
        // WelcomeModule,
        , WelcomePageComponent,
        DonationOptoutModalComponent,
        MyCampaignModalComponent,
        LoginPageComponent,
        LoginEntryComponent,
        LandingPageComponent,
        ForgotPasswordComponent,
        StandaloneForgotPasswordComponent,
        ResetPasswordComponent,
        MfaComponent,
        MFAInputAriaLabelDirective,
        AppSelectionComponent,
        UserRegistrationFeedbackComponent,
        RegistrationTokenVerificationComponent,
        ChangePasswordFormComponent,
        ChangePasswordComponent,
        PasswordExpiredComponent], providers: [
        // CDK 21's native Popover-based overlay positioning drifts from its trigger on scroll (2693) — fall back to the legacy strategy.
        { provide: OVERLAY_DEFAULT_CONFIG, useValue: { usePopover: false } },
        AuthPagesResolver, CampaignStateService, DonorCampaignsListResolver, SelectDonorCampaignsListResolver, provideHttpClient(withInterceptorsFromDi())] })
export class AppModule { }

